import { Component, Inject, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Carrier, FormMode, FileParseStatus, CarrierInvoiceFile } from 'src/app/_models/models';
import { AlertService, AlertMessage, AlertSeverity, AlertOptions, AlertTypes } from 'src/app/alert/alert.component';
import { CarriersService } from 'src/app/services/api/carriers.service';
import { CarrierInvoiceFilesService } from 'src/app/services/api/carrier-invoice-files.service';
import { CommonService } from 'src/app/services/common.service';
import { RouterOutlet } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { SnackbarComponent } from 'src/app/Shared Components/snackbar/snackbar.component';
import { SnackBarService } from 'src/app/services/SharedServices/snack-bar.service';
import { MessagePopupComponent } from 'src/app/Shared Components/message-popup/message-popup.component';
import { MatDialog } from '@angular/material/dialog';
// import { SelectItem } from 'primeng/api/selectitem';
import { SelectItem } from 'primeng/api';

export interface UserData {
  id: string;
  name: string;
  progress: string;
  fruit: string;
}

/** Constants used to fill up our data base. */
const FRUITS: string[] = [
  'blueberry', 'lychee', 'kiwi', 'mango', 'peach', 'lime', 'pomegranate', 'pineapple'
];
const NAMES: string[] = [
  'Maia', 'Asher', 'Olivia', 'Atticus', 'Amelia', 'Jack', 'Charlotte', 'Theodore', 'Isla', 'Oliver',
  'Isabella', 'Jasper', 'Cora', 'Levi', 'Violet', 'Arthur', 'Mia', 'Thomas', 'Elizabeth'
];
@Component({
  selector: 'app-invoicing-carrier-index-component',
  templateUrl: './carrier.component.html',
  styleUrls: ['./carrier.component.scss']
})


export class InvoicingCarrierIndexComponent {

  @ViewChild(RouterOutlet) outlet: RouterOutlet;

  _http: HttpClient;
  public CarrierControllerUrl: string;
  public CarrierInvoiceFileControllerUrl: string;

  public Carriers: Carrier[];
  public Carrier: Carrier;
  public InvoiceFiles: CarrierInvoiceFile[];
  public InvoiceFile: CarrierInvoiceFile;
  public InvoiceFilesDtCols = [
    // { field: 'id', header: 'Id' },
    { field: 'label', header: 'Carrier Invoice Name' },
    { field: 'name', header: 'Carrier' },
    { field: 'fileOriginalName', header: 'Name' },
    { field: 'fileVersion', header: 'Ver.' },
    { field: 'uploadedOn', header: 'Date' },
    { field: 'status', header: 'Status' }
  ];

  public Mode: FormMode = FormMode.None;
  public FormModes = FormMode;
  public FileParseStatus = FileParseStatus;

  engines: SelectItem[] = [
    { label: "FX", value: "FX" },
    { label: "GLS", value: "GLS" },
    { label: "UPS", value: "UPS" },
    { label: "Better Trucks", value: "BetterTrucks" },
    { label: "TLS Parcel", value: "TLS" }
  ];

  constructor(private carriers: CarriersService, private carrierInvoiceFiles: CarrierInvoiceFilesService, private alert: AlertService, private comm:CommonService,
    private _snackBar: MatSnackBar, private snackservice: SnackBarService, private dialog : MatDialog) {
    this.InvoiceFile = new CarrierInvoiceFile();
    const users = Array.from({length: 100}, (_, k) => this.createNewUser(k + 1));

    // Assign the data to the data source for the table to render
    //this.CarrierControllerUrl = baseUrl + 'api/carriers';
    this.CarrierInvoiceFileControllerUrl = comm.getApiAddress() + '/CarrierInvoiceFiles';
    //this._http = http;

    this.alert.Receiver.subscribe((receiver) => {
      //alert(receiver.Response);
    });

    // this.loadProviders((carriers: Carrier[]) => {
    //   this.Carriers = carriers;
    // });

    this.loadCarriers((carriers: Carrier[]) => {
      this.Carriers = carriers;
      this.loadInvoiceFiles(this.Carriers, null, (result: CarrierInvoiceFile[]) => {
        var invResult = [];
        for ( let i = 0; i < result.length; i++) {
          var temp = {
            id : result[i].id,
            label:result[i].label,
            fileOriginalName:result[i].fileOriginalName,
            fileVersion:result[i].fileVersion,
            fileName:result[i].fileName,
            filePath:result[i].filePath,
            uploadedOn:result[i].uploadedOn,
            carrierId:result[i].carrierId,
            status:result[i].status,
            statusLog:result[i].statusLog,
            carriername:result[i].Carrier.name
          }
          invResult.push(temp);
        }
        // this.InvoiceFiles = result;
        this.InvoiceFiles = invResult;
        this.dataSource = new MatTableDataSource( this.InvoiceFiles);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
    });
  }

  public onSubmit(form: any) {
    switch (this.Mode) {
      case FormMode.Find: {
        this.loadInvoiceFiles(this.Carriers, this.FileLabel, (result: CarrierInvoiceFile[]) => {
          this.InvoiceFiles = result;
        });
        break;
      }
      case FormMode.New: {
        if (form.invalid) {

        } else {
          this.post(form);
        }
        break;
      }
      case FormMode.Del: {
        this.delete();
        break;
      }
      default: {
        break;
      }
    }
  }
  displayedColumns: string[] = ['Label', 'Carrier', 'Name','Ver.','Date','Status',"..."];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  ngAfterViewInit() {
    if (this.dataSource != undefined) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  public post(form: any) {
    this.carrierInvoiceFiles.create(this.Carrier).subscribe(result => {
      form.resetForm();
      this.resetForm();
      this.loadInvoiceFiles(this.Carriers, null, (result: CarrierInvoiceFile[]) => {
        this.InvoiceFiles = result;
      });
      this.resetForm();
      // this.alert.send(new AlertMessage("CarrierInvoiceInsertFailSuccess", "Saved sucessfully", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Toast }));
      this.openSnackBar('Saved sucessfully', 'success');

    }, error => function (ex) {
      // this.alert.send(AlertMessage.getOnHttpError("CarrierInvoiceInsertFail", "Failed to save", error));
      this.openSnackBar('Failed to save', 'error');

    });
  }

  public delete() {


    this.dialog
    .open(MessagePopupComponent, {
      data: {
        cancelText: 'Cancel',
        confirmText: 'Delete',
        message: 'Are you sure you want to DELETE the selected invoice?',
        title:'Delete Invoice'
        // alertcontent: '*you cannot undo the changes',
      },
    })
    .afterClosed()
    .subscribe((res) => {
      if (res) {
        this.invoiceDelete();

      }
    });

  }

  public invoiceDelete(){
    this.carrierInvoiceFiles.delete(this.InvoiceFile.id).subscribe(result => {
      this.resetForm();
      this.loadInvoiceFiles(this.Carriers,null, (result: CarrierInvoiceFile[]) => {
        this.InvoiceFiles = result;
        this.dataSource = new MatTableDataSource( this.InvoiceFiles);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        // location.reload();
      });
      // this.alert.send(new AlertMessage("CarrierInvoiceDeleteSuccess", "Deleted sucessfully", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Toast }));
      this.openSnackBar('Deleted sucessfully', 'success');

    }, error => {
      // this.alert.send(AlertMessage.getOnHttpError("CarrierInvoiceDeleteFail", "Failed to delete", error));
      this.openSnackBar('Failed to delete', 'error');

    });
  }

  public loadInvoiceFiles(carriers: Carrier[], label:string, onSuccess: (invoiceFiles: CarrierInvoiceFile[]) => void) {
   //debugger;
    this.carrierInvoiceFiles.getAll(label).subscribe(result => {
      result.forEach((e) => {
       //debugger;
        var c = carriers.find(p => p.id == e.carrierId);
        // var c = carriers.find(p => p.engine == e.Carrier.engine);
        // var c = carriers.find(p => p.engine == e.engine);
        if (c != null) {
          e.Carrier = c;
        }
      });

      if (onSuccess != null) {
        onSuccess(result);
      }
    }, error => {
      // this.alert.send(AlertMessage.getOnHttpError("CarrierInvoiceFileGetFail", "Failed to get invoice files", error));
      this.openSnackBar('Failed to get invoice files', 'error');

    });
  }

  public loadCarriers(onSuccess: (carriers: Carrier[]) => void) {
   //debugger;
    this.carriers.getAll(null).subscribe(result => {
      if (onSuccess != null) {
        onSuccess(result);
      }
    }, error => function (ex) {
      // this.alert.send(AlertMessage.getOnHttpError("GetCarrierListFail", "Failed to get cariers", error));
      this.openSnackBar('Failed to get cariers', 'error');

    });
    // this.carriers.getAllProviders().subscribe(result => {
    //  //debugger;
    //   if (onSuccess != null) {
    //    //debugger;
    //     onSuccess(result);
    //   }
    // }, error => function (ex) {
    //  //debugger;
    //   this.alert.send(AlertMessage.getOnHttpError("GetCarrierListFail", "Failed to get cariers", error));
    //   //this.openSnackBar('Failed to get cariers', 'error');
    // });
  }

  // public loadCarriers(onSuccess: (carriers: Carrier[]) => void) {
  //  //debugger;
  //   // this.carriers.getAll(null).subscribe(result => {
  //   //   if (onSuccess != null) {
  //   //     onSuccess(result);
  //   //   }
  //   // }, error => function (ex) {
  //   //   // this.alert.send(AlertMessage.getOnHttpError("GetCarrierListFail", "Failed to get cariers", error));
  //   //   this.openSnackBar('Failed to get cariers', 'error');

  //   // });
  //   this.carriers.getAllProviders().subscribe(result => {
  //    //debugger;
  //     if (onSuccess != null) {
  //      //debugger;
  //       onSuccess(result);
  //     }
  //   }, error => function (ex) {
  //    //debugger;
  //     this.alert.send(AlertMessage.getOnHttpError("GetCarrierListFail", "Failed to get cariers", error));
  //     //this.openSnackBar('Failed to get cariers', 'error');
  //   });
  // }

  public loadProviders(onSuccess: (carriers: Carrier[]) => void) {
    this.carriers.getAllProviders().subscribe(result => {
      if (onSuccess != null) {
        onSuccess(result);
      }
    }, error => function (ex) {
      // this.alert.send(AlertMessage.getOnHttpError("GetCarrierListFail", "Failed to get cariers", error));
      this.openSnackBar('Failed to get cariers', 'error');

    });
  }

  FileLabel: string;

  public resetForm() {
    this.loadInvoiceFiles(this.Carriers, null, (result: CarrierInvoiceFile[]) => {
      this.InvoiceFiles = result;
      this.dataSource = new MatTableDataSource( this.InvoiceFiles);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
    
    if (this.Mode == FormMode.Find) {
      this.FileLabel = null;
      this.loadInvoiceFiles(this.Carriers, null, (result: CarrierInvoiceFile[]) => {
        this.InvoiceFiles = result;
        this.dataSource = new MatTableDataSource( this.InvoiceFiles);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    }

    this.Mode = FormMode.None;
    this.InvoiceFile.selected = false;
    this.InvoiceFile = new CarrierInvoiceFile();
  }

  public showFind() {
    this.Mode = FormMode.Find;
    this.InvoiceFile.selected = false;
    this.InvoiceFile = new CarrierInvoiceFile();
  }

  public showNew() {
    this.Mode = FormMode.New;
    this.InvoiceFile.selected = false;
    this.InvoiceFile = new CarrierInvoiceFile();
  }

  public showDel(p: CarrierInvoiceFile) {
    this.Mode = FormMode.Del;
    this.InvoiceFile.selected = false;
    this.InvoiceFile = p;
    this.InvoiceFile.selected = true;
  }

  public upload(e: any) {


  }

  public dealWithFiles(e: any) {

  }

  // public onBeforeUpload(e: any) {

  //   e.formData.append('CarrierId', this.Carrier.id);
  //   e.formData.append('FileLabel', this.InvoiceFile.label);
  // }

  public onBeforeUpload(e: any) {
    this.snackservice.loader();
    const formData: FormData = new FormData();
    // e.formData.append('CarrierId', this.Carrier.id);
    e.formData.append('CarrierId', this.Carrier);
    e.formData.append('FileLabel',   this.InvoiceFile.label);
  }

  public onUploadComplete(e: any) {
    setTimeout(() => {
      this.snackservice.CloseProgressSpinner(true);
    },300);
    if (e.originalEvent.body == null) {
    // this.alert.send(new AlertMessage("CarrierInvoiceFileUploadCompleted", "Invoice file uploaded sucessfully", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Toast }));
      this.openSnackBar('Invoice file uploaded sucessfully', 'success');
    } else {
      if (e.originalEvent.body == "LabelExist") {
        this.openSnackBar('Carrier Invoice already exists with this label', 'error');
      } else if (e.originalEvent.body.active == false) {
        // this.alert.send(new AlertMessage("CarrierRateFileUploadError", "Rate file upload failed", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Toast }));
        this.openSnackBar('Upload invoice file format is not proper or already exists with same invoice number', 'error');
      }
    }
    this.resetForm();
    this.loadInvoiceFiles(this.Carriers, null, (result: CarrierInvoiceFile[]) => {
     //debugger;
      this.InvoiceFiles = result;
      this.dataSource = new MatTableDataSource( this.InvoiceFiles);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      // setTimeout(() => {
      //   this.snackservice.CloseProgressSpinner(true);
      // },300);
    });

  }

  public onUploadError(e: any) {
    setTimeout(() => {
      this.snackservice.CloseProgressSpinner(true);
    },300);
    if (e.error == undefined || e.error == null) {
      // this.alert.send(new AlertMessage("CarrierInvoiceFileUploadError", "Invoice file upload failed", AlertSeverity.Error));
      this.openSnackBar('Invoice file upload failed', 'error');
    }
    else {
      // this.alert.send(AlertMessage.getOnHttpError("CarrierInvoiceFileUploadError", "Invoice file upload failed", e.error));
      this.openSnackBar('Invoice file upload failed', 'error');
    }
    this.resetForm();
  }

  public viewInvoiceFile(p: CarrierInvoiceFile) {
    this.InvoiceFile.selected = false;
    this.InvoiceFile = p;
    this.InvoiceFile.selected = true;
    if (this.InvoiceFile.status != this.FileParseStatus.Completed) {
      // this.alert.send(new AlertMessage("CarrierInvoiceFileNotReady", "File status isn't 'Completed'", AlertSeverity.Warning));
      this.openSnackBar("File status isn't 'Completed'", 'notification');

    } else {
      // this.alert.send(new AlertMessage("CarrierInvoiceFeatureNotReady", "Feature isn't ready", AlertSeverity.Information));
      this.openSnackBar("File status isn't 'Completed'", 'notification');

    }
  }
  public createNewUser(id: number): UserData {
    const name = NAMES[Math.round(Math.random() * (NAMES.length - 1))] + ' ' +
      NAMES[Math.round(Math.random() * (NAMES.length - 1))].charAt(0) + '.';

    return {
      id: id.toString(),
      name: name,
      progress: Math.round(Math.random() * 100).toString(),
      fruit: FRUITS[Math.round(Math.random() * (FRUITS.length - 1))]
    };
  }

  public viewFileProcessingError(p: CarrierInvoiceFile) {
    // this.alert.send(new AlertMessage("CarrierInvoiceFileProcessingError", "Uploaded file read error: <hr/> " + p.statusLog, AlertSeverity.Fatal));
    this.openSnackBar("Uploaded file read error: <hr/> ", 'notification');

  }

  openSnackBar(message: string, messageType:'error'|'success'|'notification') {
    let config = new MatSnackBarConfig();
    config.data = {
      message: message,
      type:messageType
    };
    config.duration = environment.messageTimeOut;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.panelClass =messageType;
    this._snackBar.openFromComponent(SnackbarComponent, config);
  }

 

}
